import { JSX } from 'react';
import CompanyCalculatorForm from '../components/calculator-form/company-calculator/CompanyCalculator';
import PersonalCalculatorForm from 'components/calculator-form/personal-calculator/PersonalCalculator';
import TripsCalculator from '../components/calculator-form/trips-calculator/TripsCalculator';
export const calculatorForms: Record<string, React.FC> = {
  'company-calculator': CompanyCalculatorForm,
  'personal-calculator': PersonalCalculatorForm,
  'trips-calculator': TripsCalculator,
};

export default calculatorForms;
